<template>
  <div class="ptStarka-footer">
    <div class="footer-box">
      <div class="list">
        <img src="../assets/address.png" alt="">
        <div>
          <p>Địa chỉ công ty</p>
          <span>Belleza BSA ist Floor Unit 106 Jalan Letjen Soepeno , Desa/Keluraran
            Grogol Utara, Kec.Kebayoran Lama, Kola Adm, Jakarta Selatan, Provins
            DKi Jakarta.</span>
        </div>
      </div>
      <div class="list">
        <img src="../assets/tel.png" alt="">
        <div>
          <p>Mã bài</p>
          <span>85819578176</span>
        </div>
      </div>
      <div class="list">
        <img src="../assets/email.png" alt="">
        <div>
          <p>Thư</p>
          <span>amanda@ptstarkapro.com</span>
        </div>
      </div>
    </div>
    <div class="bottom">
      © Copyright @VayDễ
    </div>
  </div>
</template>
<script>
export default {
  name: "fotter",
  data() {
    return {
    };
  },
  methods: {
    sendInfo() {
      alert('Berhasil dikirim')
    }
  },
};
</script>
<style lang="less" scoped>
.ptStarka-footer {
  background-size: 100% 100%;
  box-sizing: border-box;

  .footer-box {
    display: flex;
    padding: 80px 360px 80px;
    background: #E1D610;
    box-sizing: border-box;

    .list {
      display: flex;
      width: 33.3%;

      img {
        margin-right: 16px;
        width: 72px;
        height: 72px;
      }

      div {
        p {
          font-weight: 600;
          font-size: 32px;
          color: #1E1D21;
          line-height: 45px;
        }

        span {
          font-weight: 600;
          font-size: 14px;
          color: #1E1D21;
          line-height: 20px;
        }
      }
    }
  }

  .bottom {
    background: #000001;
    text-align: center;
    padding: 26px 0;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 24px;
  }
}
</style>
